import React, { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import {
  appendMandatorySignAndTimezoneText,
  UTCWithTimezoneToISOString,
  dateObjectToServerFormat,
  getAgeInYears,
  getAgeInYearsWithMoment,
  serverFormatToMomentObject,
} from "../../../system";
import { allSharedComponents } from "../../../shared";
import {
  globalConstants,
  nationalityConstants,
  translationConstants,
} from "../../../constants";
import moment from "moment";

const BecomeVerifiedUser = (props) => {
  const { Mandatory_Character } = globalConstants;
  const { t } = useTranslation();
  const { FileUploader, ReactDatePickerWrapper } = allSharedComponents;

  const [ageInYears, setAgeInYears] = useState(0);
  const [documentUpload, setDocument] = useState("0");
  const [validationErrorMessage, setValidationErrorMessage] = useState("");

  const {
    unregister,
    reset,
    setValue,
    formState: { errors },
    getValues,
    register,
    trigger,
    control,
  } = useFormContext();

  const handleCNICPassportChange = (event) => {
    setValue("documentType", event.target.value, { shouldValidate: true });
    setDocument(event.target.value);
  };

  const handleFileUpload = useCallback(
    (file) => {
      setValue("uploadImage", file, { shouldValidate: true });
    },
    [setValue]
  );

  const calculateAge = () => {
    let dobString = props.dobString;

    let age = getAgeInYearsWithMoment(dobString);
    setAgeInYears(age);
    if (age < 14) {
      const originalDate = serverFormatToMomentObject(dobString)
        .add(14, "years")
        .toDate();
      if (documentUpload === "2") {
        setValue("expiredateString", originalDate);
      } else {
        setValue("expiredateString", null);
      }
    } else {
      setValue("expiredateString", null);
    }
  };
  useEffect(() => {
    return () => {
      reset({
        ...getValues(),
        uploadImage: undefined,
        documentType: undefined,
        nationalIdentity: undefined,
        expiredateString: undefined,
      });
      unregister([
        "uploadImage",
        "documentType",
        "nationalIdentity",
        "expiredateString",
      ]);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    calculateAge();
    // eslint-disable-next-line
  }, [props.countryId, props.dobString, documentUpload]);

  return (
    <Form noValidate className="RegisterationDataForm ">
      <div className="w-100">
        <p className="verified-user-text">
          {t(translationConstants.BECOME_A_VERIFIED_USER)}
        </p>
        <p className="uploadPara mt-14">
          {t(translationConstants.pleaseSelectOne)}:
        </p>

        {/* Form for selecting National ID or Passport */}
        <Form className="w-100">
          <div className="d-flex radio-button">
            <Form.Check
              inline
              label={t(translationConstants.nationalID)}
              value={0}
              checked={documentUpload === "0"}
              type="radio"
              id="inline-radio-3"
              {...register("documentType", {
                required: t(translationConstants.documentTypeRequired),
              })}
              onChange={handleCNICPassportChange}
            />
            {props.countryId !== nationalityConstants.SAUDIA_ARABIA ? (
              <Form.Check
                inline
                label={t(translationConstants.passport)}
                value={1}
                checked={documentUpload === "1"}
                type="radio"
                id="inline-radio-3"
                {...register("documentType", {
                  required: t(translationConstants.documentTypeRequired),
                })}
                onChange={handleCNICPassportChange}
              />
            ) : props.countryId === nationalityConstants.SAUDIA_ARABIA &&
              parseInt(ageInYears) < 14 ? (
              <Form.Check
                inline
                label={t(translationConstants.FAMILY_CARD)}
                value={2}
                checked={documentUpload === "2"}
                type="radio"
                id="inline-radio-4"
                {...register("documentType", {
                  required: t(translationConstants.documentType),
                })}
                onChange={handleCNICPassportChange}
              />
            ) : (
              ""
            )}
          </div>
          {errors.documentType && (
            <p className="errorText">{errors.documentType.message}</p>
          )}
        </Form>
        <div className={`${props.isBecomeVerifiedUser ? "verified-user" : ""}`}>
          <p className="idImagePara">
            {t(translationConstants.UploadDocument)}:{Mandatory_Character}
          </p>
          <div className="filterUploader">
            <FileUploader
              {...register("uploadImage", {
                required: t(translationConstants.imageRequired),
              })}
              onFileUpload={handleFileUpload}
              setValidationErrorMessage={setValidationErrorMessage}
              isError={errors.uploadImage || validationErrorMessage}
            />
            {errors.uploadImage && !validationErrorMessage && (
              <p className="errorText">{errors.uploadImage.message}</p>
            )}
            {validationErrorMessage && (
              <p className="errorText">{validationErrorMessage}</p>
            )}
          </div>
          <div className={`${props.isBecomeVerifiedUser ? "" : "inputRow"}`}>
            <Form.Group
              className={`${
                props.isBecomeVerifiedUser
                  ? "verified-user-input-row"
                  : "form-group"
              }`}
            >
              <Form.Label className="Form-labels">
                {t(translationConstants.documentNo)}:{Mandatory_Character}
              </Form.Label>
              <Form.Control
                {...register("nationalIdentity", {
                  required: t(translationConstants.nationalIDNumberRequired),
                  maxLength: {
                    value: 200,
                    message: t(translationConstants.nationalIDLength), // Assuming it's 200 digits, adjust as necessary
                  },
                })}
                id="nationalIdentity"
                type="text"
                placeholder="abcd00000000"
              />
              {errors.nationalIdentity && (
                <p className="errorText">{errors.nationalIdentity.message}</p>
              )}
            </Form.Group>
            {props.isBecomeVerifiedUser ? <br /> : ""}
            <Form.Group
              className={`${
                props.isBecomeVerifiedUser
                  ? "verified-user-input-row"
                  : "form-group"
              }`}
            >
              <Form.Label className="Form-labels">
                {appendMandatorySignAndTimezoneText(
                  t(translationConstants.expiryData),
                  t
                )}
              </Form.Label>
              <Controller
                className="cursor-pointer"
                name="expiredateString"
                control={control}
                rules={{
                  required: t(translationConstants.expiryDateRequired),
                }}
                render={({ field }) => (
                  <ReactDatePickerWrapper
                    minDate={new Date(UTCWithTimezoneToISOString())}
                    disabled={documentUpload === "2"}
                    onChange={(date) => {
                      // Check if documentUpload is "2" and set the value accordingly
                      if (documentUpload === "2") {
                        //Assuming expiryDate is in milliseconds
                        setValue("expiredateString", date, {
                          shouldValidate: true,
                        });
                        trigger("expiredateString");
                      } else {
                        field.onChange(date);
                      }
                    }}
                    selected={field.value}
                    value={field.value}
                  />
                )}
              />
              {errors.expiredateString && (
                <p className="errorText">{errors.expiredateString.message}</p>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default BecomeVerifiedUser;
